import axios from 'axios';

export default function createActions($i18n) {
	const setLanguage = ({ commit }, lang) => {
		commit('SET_LANGUAGE', { lang });
	};

	const loadLanguage = async ({ commit, dispatch }, { lang = 'en-GB' }) => {
		const { data } = await axios.get(`${window.$config.localesUrl}/${lang}.json`, {
			params: {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}
		});
		// Replace the url with this one to load a mock tokens file if provided in the /static folder
		// http://localhost:3001/static/tokens.json
		const tokens = data;
		$i18n.locale = lang;
		$i18n.setLocaleMessage(lang, tokens);
		document.querySelector('html').setAttribute('lang', lang);
		commit('SET_TOKENS', { tokens });
	};

	return { setLanguage, loadLanguage };
}
